import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { P } from '@mxenabled/mxui'

import { SearchBox, useGlobalCopyStore } from '../../../../common'
import { isEligibleRepeatingTransaction } from '../../../../core/utils/RecurringTransactionsUtil'
import { TransactionList, useTransactionsUiStore } from '../../../../transactions'

interface SelectTransactionProps {
  bgcolor?: string
  description?: string
  onSearch: (value: string) => void
  onSelected: (guid: string) => void
}

export const SelectTransaction = observer(
  ({
    bgcolor = 'background.default',
    description,
    onSearch,
    onSelected,
  }: SelectTransactionProps) => {
    const { recurring: recurringCopy } = useGlobalCopyStore()
    const { searchValue, setSearchValue } = useTransactionsUiStore()

    return (
      <Stack sx={{ bgcolor, gap: 16, pt: 8 }}>
        {description && <P sx={{ mx: 24 }}>{description}</P>}
        <SearchBox
          ariaLabel={recurringCopy.select_transaction_search_aria}
          cancelAriaLabel={recurringCopy.select_transaction_search_cancel_aria}
          onChange={(value) => {
            setSearchValue(value)
            onSearch(value)
          }}
          placeholder={recurringCopy.select_transaction_search_placeholder}
          searchValue={searchValue}
        />
        <TransactionList
          bgcolor={bgcolor}
          filter={isEligibleRepeatingTransaction}
          height="auto"
          onClick={onSelected}
          showLoader={false}
        />
      </Stack>
    )
  },
)
